import React from "react";

const EntityEmpty = props => {
  return <div className="fantastic-elements__empty" />;
};

export default EntityEmpty;
